import { render, staticRenderFns } from "./AvalonEditorSuperadmin.vue?vue&type=template&id=0c2b8d5d&scoped=true&"
import script from "./AvalonEditorSuperadmin.vue?vue&type=script&lang=js&"
export * from "./AvalonEditorSuperadmin.vue?vue&type=script&lang=js&"
import style0 from "./AvalonEditorSuperadmin.vue?vue&type=style&index=0&id=0c2b8d5d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2b8d5d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCol,VFadeTransition,VProgressCircular,VRow,VSheet})
